<template>
    <default-modal
        ref="box"
        :title="title"
        :modalWidth="600"
        :confirmTxt="confirmText"
        @confirm="confirm"
    >
        <div class="modal-body">
            <div>
                <div class="row">
                    <span class="left">移动到：</span>
                    <select v-model="safeGroupId">
                        <option value="">请选择目标安全组</option>
                        <option
                            v-for="(item, index) in allSecurityGroup"
                            :key="index"
                            v-text="item.securityName"
                            :value="item.id"
                        ></option>
                    </select>
                </div>
            </div>
        </div>
    </default-modal>
</template>
<script>
import DefaultModal from "_c/modals/defaultModal";
import { moveSecurityGroup } from "@/requests/securityCenter";
import { mapState, mapActions } from "vuex";
export default {
    components: {
        DefaultModal
    },
    data() {
        return {
            safeGroupId: "",
            barIds: "",
            title: "移动安全组",
            confirmText: "保存",
            successFn: ""
        };
    },
    computed: {
        ...mapState({
            allSecurityGroup: state => state.securityCenter.allSecurityGroup
        })
    },
    mounted() {
        window.$modal.moveSafeGroup = {};
        window.$modal.moveSafeGroup.show = barIds => {
            this.barIds = barIds;
            return new Promise(resolve => {
                this.init(() => {
                    resolve(true);
                });
            });
        };
    },
    methods: {
        ...mapActions(["securityCenter/actionSetSecurityInfo"]),
        // 初始化信息
        init(fn) {
            this.$refs.box.show();
            this.successFn = fn;
        },
        async confirm() {
            if (!this.safeGroupId) {
                return this.$refs.box.setWrong("请选择目标安全组");
            }
            let resValue = await moveSecurityGroup({
                barId: this.barIds,
                securityGroupId: this.safeGroupId
            });
            if (resValue.code == 200) {
                this["securityCenter/actionSetSecurityInfo"]();
                this.$refs.box.hide();
                this.successFn();
            } else {
                this.$refs.box.setWrong(resValue.msg);
            }
        }
    }
};
</script>
<style lang="scss" scoped>
@import "_style/_color.scss";

.modal-body {
    padding: 10px;
    padding-left: 30px;
    padding-right: 30px;
    text-align: left;
    .row {
        height: 30px;
        line-height: 30px;
        overflow: hidden;
        margin: 10px 0 30px 60px;
        .left {
            float: left;
            color: #a1a1a1;
            margin-right: 10px;
            min-width: 85px;
            display: inline-block;
            text-align: right;
            height: 30px;
            line-height: 30px;
        }
    }
    select {
        width: 250px;
        height: 30px;
        border: 1px solid rgba(230, 230, 230, 1);
    }
}
</style>
